import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setAuthToken } from '../store/authSlice';
import { setPersonId } from '../store/userSlice';
import { readAuthFromSearch, readPersonFromSearch } from '../utils/authSearch';

/**
 * When the URL contains `?auth=` or `?p=`, writes JWT and person id into persisted Redux state.
 */
export default function AuthUrlSync() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const auth = readAuthFromSearch(location.search);
    if (auth) {
      dispatch(setAuthToken(auth));
    }
    const personId = readPersonFromSearch(location.search);
    if (personId) {
      dispatch(setPersonId(personId));
    }
  }, [location.search, dispatch]);

  return null;
}
